
import { Vue } from "vue-class-component";

export default class PlaneDeparture extends Vue {}
